var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMenuUnreadOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21529_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 2.33301H7.00008C4.48592 2.33301 3.22885 2.33301 2.44779 3.11405C1.66675 3.89511 1.66675 5.15218 1.66675 7.66634V11.4174M5.86784 14.333H8.33342C10.8475 14.333 12.1047 14.333 12.8857 13.5519C13.6667 12.7709 13.6667 11.5138 13.6667 8.99967V8.33301",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 4.00033C14.3334 5.28899 13.2887 6.33366 12.0001 6.33366C10.7114 6.33366 9.66675 5.28899 9.66675 4.00033C9.66675 2.71166 10.7114 1.66699 12.0001 1.66699C13.2887 1.66699 14.3334 2.71166 14.3334 4.00033Z",
    fill: "#0095FF",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8H6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11H10",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.1562L8.30451 7.82832",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21529_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuUnreadOff);
export default __webpack_public_path__ + "static/media/group_menu_unread_off.9c086cf01a05950dcc0ddcbcfadac7f3.svg";
export { ForwardRef as ReactComponent };